import Select, { SelectProps } from 'antd/lib/select';
import _, { isEmpty, isNull, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { getChildParList, getParList } from '../../services/parametersService';

export type ParListSelectProps = SelectProps<any> & {
  parcode: string;
  parvalueparent?: string;
  onlywithparvalueparent?: boolean;
  hidden?: boolean;
};

const ParListSelectWithLabelInValue = (props: ParListSelectProps) => {
  const {
    parcode,
    parvalueparent,
    onlywithparvalueparent,
    onChange = noop,
    hidden,
    value,
    ...rest
  } = props;
  const [labelInVal, setlabelInVal] = useState<any>(true);

  let ltpid =
    Number(
      isNull(localStorage.getItem('tpid')) ? 0 : localStorage.getItem('tpid')
    ) ?? 0;
  if (isNaN(ltpid)) {
    ltpid = 0;
  }
  const { data: parList } = useQuery(
    ['getParList', { parcode }],
    () => getParList({ parcode, tpid: ltpid }).then((res) => res.list || []),
    {
      staleTime: MINUTE,
      enabled: !onlywithparvalueparent && parvalueparent === undefined,
    }
  );

  const { data: childParList } = useQuery(
    ['getChildParList', { parcode, parvalueparent }],
    () =>
      getChildParList({ parcode, parvalueparent: parvalueparent! }).then(
        (res) => res.list || []
      ),
    { staleTime: MINUTE, enabled: parvalueparent !== undefined }
  );

  useEffect(() => {
    const defaultParListItem = parList?.find(
      ({ parflagdefault }) => parflagdefault
    );
    if (defaultParListItem && (isEmpty(value) || value === '')) {
      onChange({
        value: defaultParListItem?.parvalue,
        label: defaultParListItem?.parlistlabel,
        key: defaultParListItem?.id,
      });
    }
    //if (labelInVal && typeof value !== 'object') setlabelInVal(false);
  }, [parList, onChange, value]);

  const options =
    parvalueparent === undefined
      ? parList
      : childParList;

  return (
    <Select
      labelInValue={labelInVal}
      onChange={onChange}
      showSearch
      allowClear
      filterOption={(input, option) =>
        option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
          0 ||
        option?.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      value={value}
      {...rest}
    >
      {_.orderBy(options, 'parlistlabel', 'asc').map(
        ({ parvalue, parlistlabel }, i) => (
          <Select.Option value={parvalue} key={i}>
            {parlistlabel}
          </Select.Option>
        )
      )}
    </Select>
  );
};

const SECOND = 1000;
const MINUTE = 60 * SECOND;

export default ParListSelectWithLabelInValue;
